export const LOAD_DEPOSITS_LIST = 'LOAD_DEPOSITS_LIST';
export const RESET_DEPOSITS = 'RESET_DEPOSITS';
